<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="formObserver" v-slot="{ validate }">
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <div class="form-row">
                        <div class="form-group input-group-sm col-md-6">
                          <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                            <label for="Name">
                              <span class="required">*</span> {{ $t('Name') }}:
                            </label>

                            <b-form-input
                                type="text"
                                id="Name"
                                v-model="operator.name"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group input-group-sm col-md-6">
                          <ValidationProvider name="Url" rules="required" v-slot="{ errors }">
                            <label for="apn_url">
                              <span class="required">*</span> {{ $t('Url') }}:
                            </label>

                            <b-form-input
                                type="text"
                                id="apn_url"
                                v-model="operator.apn_url"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group input-group-sm col-md-6">
                          <ValidationProvider name="User" rules="required" v-slot="{ errors }">
                            <label for="apn_user">
                              <span class="required">*</span> {{ $t('User') }}:
                            </label>

                            <b-form-input
                                type="text"
                                id="apn_user"
                                v-model="operator.apn_user"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group input-group-sm col-md-6">
                          <ValidationProvider name="Password" rules="required" v-slot="{ errors }">
                            <label for="Name">
                              <span class="apn_password">*</span> {{ $t('Password') }}:
                            </label>
                            <b-form-input
                                type="text"
                                id="apn_password"
                                v-model="operator.apn_password"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong>{{ $t('Required Fields') }}</strong>
                      </span>
                      <div class="block text-right">
                        <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                          <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t('Save') }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton} from "bootstrap-vue";
import axios from "axios";

extend("required", required);

export default {
  data() {
    return {
      operator: {
        name: '',
        apn_url: '',
        apn_user: '',
        apn_password: '',
      },
      errors: undefined,
    };
  },
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },
    save() {
      const api = `${this.$store.state.api}operators`;

      if (this.operator.id) {
        this.operator._method = "PUT";
        api += "/" + this.operator.id;
      }

      axios.post(api, this.operator)
          .then(() => {
            this.$message(
                this.$t('Success'),
                this.$t('Information saved successfully'),
                "success"
            );
            this.$router.push("/operators");
          })
          .catch((error) => {
            this.$error(error);
          });
    },
    getOperators(id) {
      const api = `${this.$store.state.api}operators/${id}`;

      axios.get(api)
          .then((response) => {
            this.operator = response.data.data[0];
          })
          .catch((error) => {
            this.$error(error);
          });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getOperators(id);
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
  },
};
</script>

<style scoped>
.required {
  color: red !important;
}
</style>
  